import React from "react";

import { assetImg } from "@/modules/moduleImporter";
import { IGameTableType, ShioAnimals } from "@/types/GlobalTypes";

import "@/styles/machine_game.scss";

import { shioFightsAnimals } from "@/modules/commonMobile";
import { placeBetAmountFragment } from "@/modules/commonMachineGame";

//NEW FUNCTIONS ARE COPIED FROM m26
export default class M29 extends React.PureComponent<IGameTableType> {
	render() {
		//To help with bet insertion
		const activeBetGroup = this.props.activeBetGroup;
		const isColok = activeBetGroup && activeBetGroup.indexOf("c") >= 0;

		const activeUnsubmittedTicketRow = this.props.activeUnsubmittedTicketRow;
		const rowObject = activeBetGroup ?
			this.props.groupedUnsubmittedTickets
			[activeBetGroup]
			[activeUnsubmittedTicketRow] : null;

		const disableAllAnimals = this.props.isBetClosed || (rowObject ? rowObject.bet : 0) === 0;
		const showPlaceBetAmountMessage = !!this.props.activeBetGroup && (rowObject ? rowObject.bet : 0) === 0;

		return (
			<div className="sl-table machine-game m29">
				<div className={"betting-row"}>
					{
						shioFightsAnimals.map(animal =>
							<div className={"sl-bet" +
								(!activeBetGroup || disableAllAnimals ? " disabled" : "") +

								//Disables animal when it's selected
								(isColok && rowObject && rowObject.animals.indexOf(ShioAnimals[animal]) >= 0 ? " disabled" : "")
							}

							{...{
								pcode: this.props.pcode,
								animal: animal
							}}

								onClick={this.props.addAnimal}
								key={"m29_ball_" + animal}>

								{assetImg("m29", animal + ".svg")}
							</div>
						)
					}

					{ placeBetAmountFragment(showPlaceBetAmountMessage, this.props.langdata) }
				</div>
			</div>
		);
	}
}